// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-main[data-v-078753dd] {\n  /*50 = navbar  */\n  min-height: calc(100vh - 150px);\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  background: #f0f2f5;\n  padding: 20px;\n}\n.fixed-header+.app-main[data-v-078753dd] {\n  padding-top: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
